import { DesktopFlyOutModalStyles } from '../constants.js';
import { BUTTON_TYPES, INSERT_PLUGIN_BUTTONS, decorateComponentWithProps, TOOLBARS, getBottomToolbarModalStyles, getModalStyles } from 'wix-rich-content-editor-common';
import EmojiInsertModal from './emojiInsertModal.js';
import EmojiPluginIcon from '../icons/EmojiPluginIcon.js';
import 'react';
import '../icons/FaBell.js';
import '../icons/FaFlag.js';
import '../icons/FaHeart.js';
import '../icons/FaPaw.js';
import '../icons/FaSmile.js';
import '../icons/FaPlane.js';
import '../icons/FaUtensils.js';
import '../icons/FaRegFutbol.js';
import '../modifiers/addEmoji.js';
import '../types.js';
import './emojiPreviewModal.js';
import 'prop-types';
import 'react-custom-scrollbars';
import 'wix-rich-content-common';
import '../icons/JoyPixelsIcon.js';
import '../utils/getGroupEmojis.js';
import '../utils/convertUnicodeToEmoji.js';
import '../utils/emojiList.js';
import 'wix-rich-content-ui-components';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInsertButtons = ({
  t,
  isMobile,
  settings,
  getEditorState,
  setEditorState
}) => {
  var _a, _b;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || EmojiPluginIcon;
  const buttonProps = {
    type: BUTTON_TYPES.MODAL,
    name: INSERT_PLUGIN_BUTTONS.EMOJI,
    tooltip: t("EmojiPlugin_InsertButton_Tooltip"),
    getIcon: () => icon,
    componentData: settings.componentDataDefaults || {},
    modalElement: decorateComponentWithProps(EmojiInsertModal, __spreadValues({
      getEditorState,
      setEditorState
    }, settings))
  };
  return [
    __spreadProps(__spreadValues({}, buttonProps), {
      toolbars: settings.insertToolbars || [TOOLBARS.FOOTER, TOOLBARS.SIDE],
      modalStylesFn: ({ buttonRef, toolbarName }) => {
        return getBottomToolbarModalStyles(
          buttonRef,
          {
            customStyles: DesktopFlyOutModalStyles
          },
          toolbarName
        );
      }
    }),
    __spreadProps(__spreadValues({}, buttonProps), {
      modalStyles: getModalStyles({
        customStyles: isMobile ? {} : DesktopFlyOutModalStyles,
        fullScreen: false,
        isMobile
      }),
      toolbars: [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE]
    })
  ];
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
